module.exports = __webpack_public_path__ + "img/x12.cba5a461.jpg";